import ReducerNamespaceTypes from "enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "enums/reducer/reducerEntityPrefixTypes";
import { type PayloadAction } from "@reduxjs/toolkit";
import { type AccountAvailablePackOverview, type AssignAccountPack } from "features/Accounts/PackAssignmentModal/types";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import { fetchAvailablePacks } from "../thunks/availablePacksThunk";

interface OverviewState extends Omit<FetchingItemsState<AccountAvailablePackOverview>, "areAllLoaded"> {
  selected: AssignAccountPack[];
  areAllLoaded: boolean;
}

export const initialState: OverviewState = {
  areAllLoaded: false,
  isLoading: false,
  items: [],
  itemsCount: 0,
  currentRequestId: "",
  selected: [],
};

const availablePacksSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.AvailablePacks,
    name: "availablePacks",
  },
  initialState,
  reducers: {
    setSelectedPacks: (state, action: PayloadAction<AssignAccountPack[]>) => {
      state.selected = action.payload;
    },
  },
  thunk: fetchAvailablePacks,
});

export const { reset, setSelectedPacks } = availablePacksSlice.actions;

export default availablePacksSlice.reducer;
